import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { fetchChains } from 'utils/api/chainApi'
import { useQuery } from 'hooks'
import { DataTable, DataTablePagination } from 'components/common'
import { getColumns } from './utils'
import useModal from 'hooks/useModal'
import ConfirmDeleteChainModal from './confirmDeleteChainModal'
import { ICellRendererParams } from '@ag-grid-community/core'

type ChainTableProps = {
  isEditor: boolean
}

const ChainTable = ({ isEditor }: ChainTableProps) => {
  const [chainsData, setChainsData] = useState<any>({})
  const [loading, setLoading] = useState<boolean>(false)
  const [gridParams, setGridParams] = useState<ICellRendererParams>()

  const { search } = useLocation()
  const { getAllQueries } = useQuery()
  const { closeModal, isOpen, openModal } = useModal()

  const getChains = async () => {
    setLoading(true)
    const { limit, search: searchTerm, page } = getAllQueries()
    try {
      const { data } = await fetchChains({
        limit: limit || 10,
        page: page || 1,
        search: searchTerm,
      })
      setChainsData({ ...data })
    } catch {
      setChainsData({ docs: [] })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getChains()
  }, [search])

  const getChainToDelete = (params: ICellRendererParams) => {
    if (!isEditor) return
    setGridParams(params)
    openModal()
  }

  const columns = useMemo(
    () => getColumns(isEditor, getChainToDelete),
    [isEditor],
  )

  return (
    <>
      <DataTable
        columns={columns}
        rows={loading ? null : chainsData?.docs}
        identifier="_id"
      />

      {isEditor && (
        <ConfirmDeleteChainModal
          params={gridParams}
          closeModal={closeModal}
          isOpen={isOpen}
        />
      )}

      <DataTablePagination
        currentPage={chainsData?.page}
        totalPages={chainsData?.totalPages}
        hasNextPage={chainsData?.hasNextPage}
        hasPrevPage={chainsData?.hasPrevPage}
        limit={chainsData?.limit}
        nextPage={chainsData?.nextPage}
        prevPage={chainsData?.prevPage}
      />
    </>
  )
}

export default ChainTable
